import { formatMoneyDollars } from '../../../utils/money';
import type { PurchaseOrderDetail } from '../../../services/purchaseOrders';
import { KVRow } from '../Drawer';
import { fmtPoDate } from './poFormat';
import { ExpectedCost } from './ExpectedCost';
import { expectedCostSummary } from './poCost';
import { PurchaseOrderInvoiceLink } from './PurchaseOrderInvoiceLink';
import { PurchaseOrderZone } from './PurchaseOrderZone';

interface BillingZoneProps {
    purchaseOrder: PurchaseOrderDetail;
}

export function PurchaseOrderBillingZone({ purchaseOrder }: BillingZoneProps) {
    const hasInvoice = Boolean(purchaseOrder.vendorInvoiceNumber);
    const summary = expectedCostSummary(purchaseOrder);

    return (
        <PurchaseOrderZone
            title="Billing"
            badge={{ kind: 'billing', status: purchaseOrder.billingStatus }}
        >
            <div className="flex flex-col">
                <KVRow k="Invoice no.">
                    <PurchaseOrderInvoiceLink
                        purchaseOrderId={purchaseOrder.id}
                        invoiceNumber={purchaseOrder.vendorInvoiceNumber}
                        file={purchaseOrder.vendorInvoiceFile}
                        mimeType={purchaseOrder.vendorInvoiceMimeType}
                    />
                </KVRow>
                {hasInvoice && (
                    <>
                        <KVRow k="Due">
                            {purchaseOrder.vendorInvoiceDueDate ? (
                                fmtPoDate(purchaseOrder.vendorInvoiceDueDate)
                            ) : (
                                <span className="text-gray-400">-</span>
                            )}
                        </KVRow>
                        <KVRow k="Paid">
                            {purchaseOrder.paidAt ? (
                                <span className="text-green-600">
                                    {fmtPoDate(purchaseOrder.paidAt)}
                                </span>
                            ) : (
                                <span className="text-gray-400">unpaid</span>
                            )}
                        </KVRow>
                    </>
                )}
                <KVRow k="Expected">
                    <ExpectedCost summary={summary} />
                </KVRow>
                <KVRow k="Invoiced">
                    {purchaseOrder.vendorInvoicedAmount === null ? (
                        <span className="text-gray-400">-</span>
                    ) : (
                        formatMoneyDollars(purchaseOrder.vendorInvoicedAmount)
                    )}
                </KVRow>
            </div>
        </PurchaseOrderZone>
    );
}
